/* ═══════════════════════════════════════════════════════════════════════════
   Águas de Ipanema — histórico de produtos vistos

   ÁGUAS DE IPANEMA — RECENTLY VIEWED PAGE RULE
   The "Vistos Recentemente" page must reuse the Wishlist page visual system
   and product-card components. The fundamental difference is only the source
   of the product list.

   POR QUE NÃO REUSEI O recently-viewed-products DO TEMA: aquela seção do
   Warehouse só renderiza dentro da página de BUSCA — depende de
   `request.page_type == 'search'` e monta a lista a partir de search.terms.
   Não serve como fonte para uma página própria.

   LIMITE, dito com todas as letras: isto vive no navegador do cliente.
   Não acompanha outros aparelhos e some se o cliente limpar os dados do
   site. Nada é enviado para servidor — nenhum perfil comportamental.

   Guarda handle + timestamp, nunca HTML. Produto revisitado não duplica:
   sobe para o fim da lista (a posição mais recente).

   A lista é devolvida do MAIS ANTIGO para o MAIS RECENTE, igual à wishlist,
   porque a página de listagem inverte para exibir. Assim as duas fontes
   falam a mesma língua e a página não precisa saber de qual veio.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (window.aipVistos) return;

  var CHAVE = 'aguas_vistos';
  var LIMITE = 12;

  function ler() {
    try {
      var l = JSON.parse(localStorage.getItem(CHAVE) || '[]');
      return Array.isArray(l) ? l.filter(function (i) { return i && i.handle; }) : [];
    } catch (e) { return []; }
  }

  function gravar(lista) {
    try { localStorage.setItem(CHAVE, JSON.stringify(lista)); } catch (e) {}
  }

  /* Do mais antigo para o mais recente. */
  function lista() {
    return ler()
      .slice()
      .sort(function (a, b) { return (a.ts || 0) - (b.ts || 0); })
      .map(function (i) { return i.handle; });
  }

  function registrar(handle) {
    if (!handle) return;
    var atual = ler().filter(function (i) { return i.handle !== handle; });
    atual.push({ handle: handle, ts: Date.now() });
    /* Teto de LIMITE: o excedente sai pela ponta mais antiga. */
    atual.sort(function (a, b) { return (a.ts || 0) - (b.ts || 0); });
    if (atual.length > LIMITE) atual = atual.slice(atual.length - LIMITE);
    gravar(atual);
  }

  function limpar() { gravar([]); }

  window.aipVistos = {
    lista: lista,
    registrar: registrar,
    limpar: limpar,
    limite: LIMITE
  };

  /* Registro automático na PDP. O handle vem do data-attribute que a própria
     página publica; sem ele, nada é gravado. */
  function registrarDaPagina() {
    var no = document.querySelector('[data-aip-visto-handle]');
    if (no) registrar(no.getAttribute('data-aip-visto-handle'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registrarDaPagina);
  } else { registrarDaPagina(); }
})();
